import { useEffect, useState } from "react";
import { FirestoreService } from "../../api/firebase/firestoreService";
import { FirestoreDocumentReference } from "../../api/firebase/references";
import { LoaderMessage } from "../../components/loaderMessage/loaderMessage";
import { HealthCareFacilityModel } from "../../data-model/healthFacility";
import { LocalStorageKeys } from "../../enums/localStorageKeys";
import { getItemFromLocalStorage } from "../../utils/localStorageHelper";

const AnalyticsNew = () => {
  const [healthFacilityDataState, setHealthFacilityDataState] = useState<{
    data?: HealthCareFacilityModel;
    loading: boolean;
    error: string | null;
  }>({
    data: undefined,
    loading: false,
    error: null,
  });

  const fetchHealthFacilityData = async () => {
    setHealthFacilityDataState({ data: undefined, loading: true, error: null });
    const healthFacilityData =
      await FirestoreService.getDocument<HealthCareFacilityModel>(
        FirestoreDocumentReference.healthFacility(
          getItemFromLocalStorage(
            LocalStorageKeys.INTERNAL_ORGANIZATION_FACILITY_ID,
          ),
        ),
      );
    setHealthFacilityDataState({
      data: healthFacilityData,
      loading: false,
      error: null,
    });
  };
  useEffect(() => {
    fetchHealthFacilityData();
  }, [getItemFromLocalStorage(LocalStorageKeys.HEALTHCARE_FACILITY_ID)]);
  return (
    <div className="new-analytics-page--layout flex h-full items-center justify-center rounded-lg bg-primaryGray-16 p-4">
      {healthFacilityDataState?.loading ? (
        <div className="flex h-full w-full items-center justify-center">
          <LoaderMessage message="Loading analytics..." />
        </div>
      ) : (
        <>
          <iframe
            title="Analytics"
            width="100%"
            height="100%"
            src={healthFacilityDataState?.data?.analytics_url ?? ""}
            allowFullScreen={true}
          ></iframe>
        </>
      )}
    </div>
  );
};

export default AnalyticsNew;
